import axios from "axios";
import { capitalize } from "@mui/material";
import { getBucket, networkGlobals } from "./networkUtils";
import { get } from "http";
import { Action, NextScreenEvent } from "models/content/Comm";
import { Brand } from "models/BO/Brand";




export function toCapitalizedWords(name: string): string {
  const words: string[] = name?.match(/[A-Za-z.][a-z]*/g) || [];
  return words?.map(capitalize).join(" ");
}

export function camelcaseToSnakeCase(str: string, separator: string = "_"): string {
  if (str?.length === 0 || !str?.replace) {
    return "";
  }
  return str.replace(/[A-Z]/g, (letter) => `${separator}${letter.toLowerCase()}`);
}

export function snakeCaseToCamelCase(name: string): string {
  const upper = (match: string) => match.charAt(1).toUpperCase();
  return name.replace(/(-\w)/g, upper).replace(/_\w/g, upper);
}

export function camelCaseToCapitalizedWords(name?: string): string {
  if (!name) return "";
  const words = name.match(/[A-Z]+(?=[A-Z][a-z]+)|[A-Z]?[a-z]+|[A-Z]{2,}/g) || [];
  return words.map(word => {
    // Preserve sequences of capitals (e.g. "ID" in "userID")
    if (word.match(/^[A-Z]{2,}$/)) {
      return word;
    }
    return capitalize(word.toLowerCase());
  }).join(" ");
}

export function snakeCaseToCapitalizedWords(name: string): string {
  var words = name?.split(/_|-/) || [];

  return words.map((s) => capitalize(s.toLowerCase())).join(" ");
}

export function anyToCapitalizedWords(name: string): string {
  if (!name) return "";
  if (name.match(/[a-z]/) && !name.includes(" ")) {
  return camelCaseToCapitalizedWords(name);
  }
    return snakeCaseToCapitalizedWords(name);
}

export function daysFromNow(dateStr: string | Date | undefined): number {
  const d = new Date(dateStr || "");
  return Math.floor((d.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
}

export function hoursFromNow(dateStr: string | Date | undefined): number {
  const d = new Date(dateStr || "");
  return Math.floor((d.getTime() - new Date().getTime()) / (1000 * 60 * 60));
}

export function formatDateTime(dateStr: string | Date | number |  undefined): string {
  const d = new Date(dateStr || "");
  if (d.toString() == "Invalid Date") {
    return "-";
  }
  return (
    ("0" + d.getDate()).slice(-2) +
    "-" +
    d.toLocaleString("default", { month: "short" }) +
    "-" +
    d.getFullYear() +
    " " +
    ("0" + d.getHours()).slice(-2) +
    ":" +
    ("0" + d.getMinutes()).slice(-2)
  );
}

export function formatDate(dateStr: string | Date | undefined): string {
  const d = new Date(dateStr || "");
  if (d.toString() == "Invalid Date") {
    return "-";
  }
  return (
    ("0" + d.getDate()).slice(-2) +
    "-" +
    d.toLocaleString("default", { month: "short" }) +
    "-" +
    d.getFullYear()
  );
}

export function formatDateOrTime(dateStr: string | Date | undefined): string {
  const d = new Date(dateStr || "");
  if (d.toString() == "Invalid Date") {
    return "-";
  }
  
  if (d.getTime() > new Date().getTime() - 24 * 60 * 60 * 1000) {
    return ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);
  }
  if (d.getTime() > new Date().getTime() - 48 * 60 * 60 * 1000) {
    return "Yesterday";
  }
  return formatDate(dateStr);
}

export const formatTime = (miliseconds: number): string => {
  const seconds = Math.floor(miliseconds / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  if (hours > 0) {
    return `${hours}h`;
  }
  if (minutes > 0) {
    return `${minutes}m`;
  }
  return `${seconds}s`;
}

export const updateAttribute = (key: string, value: any, obj: any) => {
  const keys = key.split(".");
  let current = obj;
  for (let i = 0; i < keys.length; i++) {
    if (i === keys.length - 1) {
      current[keys[i]] = value;
    } else {
      current[keys[i]] ||= {};
      current = current[keys[i]];
    }
  }

  return obj;
};

export const avatarUrl = (profile: string | undefined, asset: string | undefined): string => {
  let bucket = getBucket();
  return `https://${bucket}.s3.amazonaws.com/protected/${profile}/${asset}.jpg`;
};

export const defaultAvatarUrl = (gender:string): string => {
  let bucket = getBucket();
  return `https://${bucket}.s3.amazonaws.com/public/uploaded/${networkGlobals.brand.folder}/png/no_pic_place_holder_${gender}.png`;
}
  

export const groupBy = function <T>(xs, func: (x: any) => any) {
  return xs.reduce(function (rv, x) {
    (rv[func(x)] = rv[func(x)] || []).push(x);
    return rv;
  }, {});
};

export const groupByArray = function (xs, func: (x: any) => string[]) {
  return xs.reduce(function (rv, x) {
    const keys = func(x);
    keys.forEach((key) => {
      (rv[key] = rv[key] || []).push(x);
    });
    return rv;
  }
  , {});
};

export const ellipsis = (str: string, length: number): string => {
  if (!str) {
    return "";
  }
  return str.length > length ? str.substring(0, length) + "..." : str;
}

export const formtHeight = (height: number): string => {
  if (isNaN(height)) {
    return "";
  }
  let feet = Math.floor(height / 12);
  let inches = Math.floor(height % 12);
  return `${feet}'${inches}"`;
};

export const toHeight = (height: string): number => {
  if (!height) {
    return 0;
  }
  let parts = height.split("'");
  if (parts.length < 2) {
    return 0;
  }
  let feet = parseInt(parts[0]);
  let inches = parseInt(parts[1].replace('"', ""));
  if (isNaN(feet) || isNaN(inches)) {
    return 0;
  }
  return feet * 12 + inches;
}

export const formatAge = (birthYear: number): string => {
  if (isNaN(birthYear)) {
    return "";
  }
  return `${new Date().getFullYear() - birthYear}`;
}

// export const camelcaseToSankeCaseAttributes = (obj) => {
//   let newObj = {};
//   for (let key in obj) {
//     if (obj[key] && typeof obj[key] === "object" && !Array.isArray(obj[key])) {
//       newObj[camelcaseToSnakeCase(key)] = camelcaseToSankeCaseAttributes(obj[key]);
//     } else {
//       newObj[camelcaseToSnakeCase(key)] = obj[key];
//     }
//   }
//   return newObj;
// }

export const snakeCaseToCamelCaseAttributes = (obj) => {
  let newObj = {};
  for (let key in obj) {
    newObj[snakeCaseToCamelCase(key)] = obj[key];
  }
  return newObj;
};
export const getDistanceInMiles = (location1: { lat: number; lng: number }, location2: { lat: number; lng: number }): number => {
  if (!location1?.lat || !location1?.lng || !location2?.lat || !location2?.lng) {
    return 0;
  }

  const toRadians = (degrees: number) => (degrees * Math.PI) / 180;

  const R = 3958.8; // Radius of the Earth in miles
  const lat1 = toRadians(location1.lat);
  const lat2 = toRadians(location2.lat);
  const deltaLat = toRadians(location2.lat - location1.lat);
  const deltaLng = toRadians(location2.lng - location1.lng);

  const a =
    Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distance in miles
};


export const uniqueBy = (arr: any[], key: string): any[] => {
  return [...new Map(arr.filter(i=>i && i[key]).map((item) => [item[key], item])).values()];
};

export async function changeFavicon(folder) {
  const oldLink = document.getElementsByTagName("link").item(0);
  if (oldLink) {
    oldLink.href = `https://alove-dev-assets.s3.amazonaws.com/public/uploaded/${folder.toLowerCase()}/png/cropped.png`;
    ;
  }
}


export function isValidUUID(uuid: string): boolean {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
}

export function numbers(obj): number[] {
  return Object.keys(obj).filter((key) => !isNaN(Number(key))).map((key) => Number(key));
}

export function names(obj): string[] {
  return Object.keys(obj).filter((key) => isNaN(Number(key))).map((key) => camelCaseToCapitalizedWords(key));
}


export function tParse(obj) {
  try {
    const o =  JSON.parse(obj);
    if (typeof o === "object") {
      return o;
    }
    return false;
  } catch (e) {
    return false;
  }
}

export const getUrlFromAction = (action: Action): string => {
  switch (action.nextEventType) {
    case NextScreenEvent.appScreen:
      return `/${action.actionUrl}`;
    default:
      return action.actionUrl?.toString() || "";
  }
}